export let evt_status : any = [
    {id:1,name:'แจ้งเตือน'},
    {id:2,name:'ตรวจสอบแล้ว'},
    {id:3,name:'ระหว่างดำเนินการ'},
    {id:4,name:'สิ้นสุด'},
    // {id:5,name:'เหตุการณ์เสร็จสิ้น'},
    {id:5,name:'ยกเลิก'},
]